import Modal from 'components/Modal'
import PurchaseTx from 'views/MemberProfile/ManualTx/PurchaseTx'

type Props = {
  title: string | undefined
  open: boolean
  onClose: () => void
}

const ModalPurchase = ({ title, open, onClose }: Props): JSX.Element => {
  return (
    <Modal open={open} title={title} onClose={onClose} noFooter>
      <PurchaseTx onClose={onClose} />
    </Modal>
  )
}

export default ModalPurchase
